(function($) {

    $(".navigation-info").each(function () {
        var $this = $( this );
        var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
            slidesPerView: 1,
            loop: $this.find('.swiper-slide').length > 1,
            autoplay: {
                delay: 5000,
            },
            speed: 400,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1200: {
                    noSwipingSelector: 'span',
                },
            },
        });
        window.onresize=function(){
            infoSlider.update();
        }
        if($this.find(".swiper-slide").length === 1){
            infoSlider.destroy();
            $(".navigation-info-nav").css("display", "none");
        }
    });

})(jQuery);
